export default __webpack_public_path__ + "static/media/bundling-shirt-page2.f06bb810.png";